import deCH from '@/assets/data/datetime/de-CH.json'
import frCH from '@/assets/data/datetime/fr-CH.json'
import enUS from '@/assets/data/datetime/en-US.json'

export default {
  'de-CH': deCH,
  'fr-CH': frCH,
  'en-US': enUS
}
